/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".comment .review-img{text-align:center;padding:10px 0;color:inherit}.comment .review-img img{max-height:450px;padding:15px 0;-o-object-fit:cover;object-fit:cover;width:90%}.comment .review-img i{display:block;color:inherit;width:90%;margin-right:0}"];
export { styles as styles };
